import { Col, Descriptions, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const RenewalVehiclePanel = ({ selected }) => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  const maskable = (text) => (
    <div className={maskSensitiveData === true ? "blurry-text" : ""}>
      {text}
    </div>
  );

  return (
    <Row>
      <Col span={24}>
        {selected && (
          <Descriptions
            size="small"
            column={3}
            items={[
              {
                key: "vehicle",
                label: "Vehicle",
                children: selected.Vehicle,
              },
              {
                key: "regNumber",
                label: "Reg Number",
                children: selected.RegNumber,
              },
              {
                key: "vehicleTypeDesc",
                label: "Vehicle Type",
                children: selected.VehicleTypeDesc,
              },
             
             
            ]}
          />
        )}
      </Col>
    </Row>
  );
};

export default RenewalVehiclePanel;
